import Auth from '~/pages/auth'
import Call from '~/pages/call'
import Preview from '~/pages/preview'
import Print from '~/pages/print'
import Sound from '~/pages/sound'
import type { RouteItem } from '~/types/route'

const routes: RouteItem[] = [
  /* Public routes */
  {
    path: '/auth/:token',
    component: Auth,
    isPrivate: false,
  },
  {
    path: '/preview',
    component: Preview,
    isPrivate: false,
  },
  {
    path: '/sound',
    component: Sound,
    isPrivate: false,
  },
  {
    path: '/print',
    component: Print,
    isPrivate: false,
  },
  {
    path: '/print/:branch',
    component: Print,
    isPrivate: false,
  },

  /* Private routes */
  {
    path: '/',
    component: Call,
    isPrivate: true,
  },
]

export default routes
